import { connect } from 'react-redux';
import { userProfile } from 'redux/saga/entities/bound';
import { deepExtract } from 'helpers/deep';
import { ReferModal } from './ReferModal';

export const mapStateToProps = state => {
  const isFriendbuyDataLoaded = deepExtract('friendbuy_info', userProfile.data(state));
  const shouldShowModal = deepExtract('request.query.refer', state);
  return {
    isOpen: !!(shouldShowModal && isFriendbuyDataLoaded),
  };
};

export const ReferModalContainer = connect(mapStateToProps)(ReferModal);
